

// -----------------------------------------------------------------[ LIBS ]--------------------------------------------------------------//
// import $ from 'jquery';

//---------- AJAX ----------------------------------------------//
import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';


//---------- ANIMATION AND SCROLL CONTROLL (TRIGGER) -----------//
import { gsap } 			from 'gsap';
import { ScrollToPlugin } 	from 'gsap/ScrollToPlugin';
import { ScrollTrigger } 	from 'gsap/ScrollTrigger';
import { ScrollSmoother } 	from 'gsap/ScrollSmoother';
// import { SlowMo } from 'gsap/EasePack';
// plugin registry gsap
gsap.registerPlugin(  ScrollToPlugin, ScrollTrigger, ScrollSmoother );

//---------- LAZYLOAD IMAGES -----------------------------------//
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import lazySizes from 'lazysizes';

lazySizes.cfg.loadMode 	= 1; // default to 2
lazySizes.cfg.expFactor = 1; //1.1; // default 1.5	
lazySizes.cfg.expand 	= 0; //100; // 370-500
lazySizes.cfg.init 		= false;

//---------- LOADING BAR ---------------------------------------//
import NProgress from 'nprogress';


//---------- MOUSE/TOUCH DETECTION -----------------------------//
import detectIt from 'detect-it';


import { clearAllBodyScrollLocks } from 'body-scroll-lock';

// this is injected in libs-head
//import SVGInject from '@iconfu/svg-inject';

// -----------------------------------------------------------------[ CONTROLLERS ]-----------------------------------------------------//
import Layout 	from './layout';
import WIDGETS 	from './widgets';
import EFFEX  	from './effex';


// ---- GLOBALS ?? (ESLINT don't bother) -----------------------//
let ga = window.ga, gtag = window.gtag, console = window.console;


// -----------------------------------------------------------------[ MAIN CLASS ]-----------------------------------------------------//
export default class{ // export class Main
	
	constructor(options) {

		// OPTIONS
		this.defaults = {
			is_ajax 				: true,
			use_prefetch 			: true,
			time_fade_in 			: 0.6,
			time_fade_out 			: 0.4,
			ease_fade_in 			: 'power1.out',
			ease_fade_out       	: 'power1.out',
			include_footer_transition: false,


			scrollSmooth 			: false,
			smooth 					: 1.7,

			$scroll_el				: 'body',
			debug					: false,
			project_name 			: 'New Project',
			redirects    			: [],

			slide_transition        : true,

			admin_button        	: '.wordpress-edit-button',

			GA_MEASUREMENT_ID 		: '', //'UA-23082040-1',
			GA_TAG_MANAGER 			: '' //'GTM-NW4KZZ'
		}

		this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 	= 'main';

		// VARS
		this.$window 	= $(window);
		this.$doc 		= $(document);
		this.$html 		= $('html');
		this.$body 		= $('body');

		this.DEVELOPMENT =  document.location.host.indexOf( 'escr-net.local' ) === -1;

		this.detectIt();

		if ( this.$html.hasClass(  'mobile' ) ){
			// this.options.scrollSmooth = false;
		}

		
		if ( this.$html.hasClass( 'ie11' ) ){
			// Sorry ie11, you fall back with normal page load ...
			this.options.is_ajax = false;
		}
		
	}

	init(){

		this.initAjax();

		lazySizes.init();

		this.initLoading();

		//--------------------------------------------------------------[ CONTROLLERS ] ---------------------------------------------------------------//
		// All JS Effects (Mostly Scroll Triggers )
		this.EFFEX 		= new EFFEX( { main: this, debug: this.options.debug } );

		// Widgets inits
		this.WIDGETS 	= new WIDGETS( { main: this } );

		// All HTML interface (Menus, Mobile Panels, etc.)
		this.LAYOUT  	= new Layout({ main: this, skip_intro: this.options.skip_intro } );

		this.initPageSpecific(this.$body, true, true);

		this.outlineInAccessibleWay();

		this._logFOUO( this.options.project_name );

		if ( !this.options.is_ajax ){
			this.onOnceReady();
		}

	}


	initScrollSmooth(b){

		//console.log( 'initScrollSmooth, b = ' + b + ', this.options.scrollSmooth = ' + this.options.scrollSmooth );
		if ( this.$html.hasClass( 'touch' ) || !this.$html.hasClass( 'desktop' ) ){
			this.options.scrollSmooth = false;
		}

		if ( !this.options.scrollSmooth  ){
			return;
		}



		if ( b ){

			if ( this.$body.hasClass( 'home' ) ){
				// return;
			}

			this.$html.addClass( 'scroll-smooth' );

			this.LAYOUT.onResize();

			let smoother  = ScrollSmoother.create({
				wrapper: '#smooth-scroll',
				content: '#smooth-content',
				smooth: this.options.smooth,               // how long (in seconds) it takes to "catch up" to the native scroll position
				effects: true,           // looks for data-speed and data-lag attributes on elements
				normalizeScroll: true,   // prevents showing/hiding of address bar, works around iOS Safari jitter, etc.
				smoothTouch: false ,     // much shorter smoothing time on touch devices (default is NO smoothing on touch devices) SET 0.1 or more if you want it
				ignoreMobileResize: true // skips ScrollTrigger.refresh() on mobile resizes from address bar showing/hiding
			});

			this.smoother = smoother;

			
		}
		else{

			if ( this.smoother ){
				this.smoother.kill();
				this.smoother = null;
			}
			
			this.$html.removeClass( 'scroll-smooth' );
		}


	}

	// -----------------------------------------------------------------[ MOUSE/TOUCH DETECTION ]-------------------------------------------------------//
	detectIt(){
		// https://github.com/rafgraph/detect-it#readme
		switch( detectIt.deviceType ){
			//'mouseOnly' / 'touchOnly' / 'hybrid'
			case 'mouseOnly':
				this.$html.addClass( 'no-touch' );
				break;
			case 'touchOnly':
				this.$html.addClass( 'touch' );
				break;
			default:
				// 'mouse' / 'touch';
				this.$html.addClass( detectIt.primaryInput === 'mouse' ? 'hybrid no-touch' : ' hybrid touch' );
		}
	}


	// -----------------------------------------------------------------[ INIT BARBA ]--------------------------------------------------------------//
	initAjax(){
		if ( this.options.is_ajax ){ 

			// tell Barba what plugins to use
			if( this.options.use_prefetch  ){
				barba.use(barbaPrefetch);
			}

			barba.init({
				
				debug: this.options.debug,

				// default 2000
				timeout: 7000, 

				// wait if a link is clicked and there is a page transition running
				preventRunning: true,

				prevent: ({ el }) => {

					if ( this.options.redirects.length > 0 ){
						let pathname = el.pathname, i = this.options.redirects.length;
						if ( pathname ){
							while( i-- ){
								if ( pathname === this.options.redirects[i][0] ){
									el.pathname = this.options.redirects[i][1];
								}
							}							
						}
					}

					return el.classList && el.classList.contains('no-barba')
				},

				/*
				prevent: ( o ) =>{
					
					let $a = $(o.el), href = $a.attr( 'href' );

					console.log( href );

					if ( $a.attr( 'target' ) === '_blank' ){
						
						console.log( 'QUIIIIIIIIIIIIIII' );

						return false;
					}
				},
				*/
				

				transitions: [

					// --------------------------- DEFAULT TRANSITION --------------------------------//
					{

						name: 'default-transition', // slide_transition, or slided_transition = false => fade

						once: () => this.onOnceReady(),

						before: (data) => this.barba_commons('before', data),

						// TRANSITION ON CURRENT PAGE
						leave: (data) => {

							// barba VIEW!
							let checkView	= this.barba_is_view( $(data.current.container), data ), 
								is_view 	= checkView[0], 
								$container	= checkView[1],
								duration 	= this.options.time_fade_out;

								//console.log( 'fade out, t = ' + duration );

							if ( is_view ){
								this.view_height = $container.height();
							}

							if ( this.options.slide_transition && !is_view ){
								let t = gsap.timeline();

								t.fromTo( $container, {y: 0 },{y: -50, opacity: 0, duration: duration, ease: 'circ.out'});
								t.fromTo( $('#curtain'), {y:"100%"}, {y:0,ease: 'circ.out', duration: duration }, '-=' + duration );

								this.$body.removeClass( 'hide-desktop-nav' );
								gsap.to(this.$window, {duration: 0.1, scrollTo: 0});
								if ( this.smoother  ){
									this.smoother.scrollTo(0);
								}

								
								return t; 
							}
							else{
								// fade out
								if ( this.options.include_footer_transition ){
									gsap.to( $('#footer'), {opacity:0, duration: duration/4, ease: this.options.ease_fade_out });
								}
								return gsap.to( $container, {
									opacity: 0,
									duration: duration, 
									ease: this.options.ease_fade_out
								});
							}
						},

						afterLeave: (data) => this.barba_commons('afterLeave', data),

						//------> Here is when data.next.container is added to the DOM!

						beforeEnter: (data) => this.barba_commons('beforeEnter', data),

						// TRANSITION ON NEXT PAGE
						enter: (data) => {

							// barba VIEW!
							let checkView	= this.barba_is_view( $(data.next.container), data ), 
								is_view 	= checkView[0], 
								$container	= checkView[1],
								duration 	= this.options.time_fade_in;

							if ( is_view ){
								if ( $container.hasClass( 'force-height' ) ){
									$container.css({
										'min-height' : this.view_height
									});									
								}
							}

							if ( this.options.slide_transition && !is_view ){
								let t = gsap.timeline();
								
								t.fromTo( $('#curtain'), {y:"0%" },{y:"-100%", ease: 'circ.out', duration: duration});
								t.fromTo( $container, {y: 100, opacity:0 },{y: 0, opacity:1, duration: duration, ease: 'circ.out', delay:0.1, onUpdate:()=>{this.afterCompletePageTransitions()},onComplete: ()=>{
									// eliminate tranform so if there are pinned elemnet they behave correctly
									gsap.set( $container, {clearProps:"all"});
									this.afterCompletePageTransitions()
								}}, '-=' + duration );							
								
								return t;

							}
							else{
								// fade In
								if ( this.options.include_footer_transition ){
									gsap.to( $('#footer'), {opacity:1, duration: duration, ease: this.options.ease_fade_in, delay: duration/2 });
								}
								return gsap.from( $container, {
									opacity: 0,
									duration: duration,
									ease: this.options.ease_fade_in,
									onComplete: () => { this.afterCompletePageTransitions( is_view, $container ) } 
								});
							}						
						},

						after: (data) => this.barba_commons('after', data)

						/*
						barba LIFECYCLE
						https://barba.js.org/docs/getstarted/lifecycle/
						*/
						/*
						once: data => this.ajaxEvent(data, 'once'),
						before: data => this.ajaxEvent(data, 'before'),
						beforeLeave: data => this.ajaxEvent(data, 'beforeLeave'),
						leave: data => this.ajaxEvent(data, 'leave'),
						afterLeave: data => this.ajaxEvent(data, 'afterLeave'),

						//------> Here is when data.next.container is added to the DOM!
						
						beforeEnter: data => this.ajaxEvent(data, 'beforeEnter'),
						enter: data => this.ajaxEvent(data, 'enter'),
						afterEnter: data => this.ajaxEvent(data, 'afterEnter'),
						after: data => this.ajaxEvent(data, 'after')
						*/

					}

					// --------------------------- CUSTON TRANSITION --------------------------------//

					/*
					,{
						name: 'ideas-category-to-ideas-category',
						from: {
							namespace: 'ideas-category'
						},
						to: {
							namespace: 'ideas-category'
						},
						before: (data) => this.barba_commons('before', data),

						// TRANSITION ON CURRENT PAGE
						leave: (data) => {

							// barba VIEW!
							let checkView	= this.barba_is_view( $(data.current.container), data ), 
								is_view 	= checkView[0], 
								$container	= checkView[1],
								duration = 0;

								//console.log( 'fade out, t = ' + duration );

							if ( this.options.slide_transition && !is_view ){
								let t = gsap.timeline();

								t.fromTo( $container, {y: 0 },{y: -50, opacity: 0, duration: duration, ease: 'Power3.easeOut'});
								t.fromTo( $('#curtain'), {y:"100%"}, {y:"0%",ease: 'Power3.easeOut', duration: duration }, '-=' + duration );
								
								return t; 
							}
							else{

								// fade out
								return gsap.to( $container, {
									opacity: 0,
									duration: duration
								});
							}
						},

						afterLeave: (data) => this.barba_commons('afterLeave', data),

						//------> Here is when data.next.container is added to the DOM!

						beforeEnter: (data) => this.barba_commons('beforeEnter', data),

						// TRANSITION ON NEXT PAGE
						enter: (data) => {

							// barba VIEW!
							let checkView	= this.barba_is_view( $(data.next.container), data ), 
								is_view 	= checkView[0], 
								$container	= checkView[1],
								duration = 0;

								//console.log( 'fade in, t = ' + duration );

							if ( this.options.slide_transition && !is_view ){
								let t = gsap.timeline();
								
								t.fromTo( $('#curtain'), {y:"0%" },{y:"-100%", ease: 'Power3.easeOut', duration: duration});
								t.fromTo( $container, {y: 300, opacity:0 },{y: 0, opacity:1, duration: duration, ease: 'Power3.easeOut', onUpdate:()=>{this.afterCompletePageTransitions()},onComplete: ()=>{
									// eliminate tranform so if there are pinned elemnet they behave correctly
									gsap.set( $container, {clearProps:"all"});
									this.afterCompletePageTransitions()
								}}, '-=' + duration );							
								
								return t;

							}
							else{

								// fade In
								return gsap.from( $container, {
									opacity: 0,
									duration: duration,
									onComplete: () => { this.afterCompletePageTransitions() } 
								});
							}						
						},

						after: (data) => this.barba_commons('after', data)					
					}

					*/

					// --------------------------- END CUSTON TRANSITION ------------------------------//
					
				]
			})
		}
	}

	afterCompletePageTransitions( is_view, $container ){
		if ( is_view ){
			return;

			$container.css({
				height: 'auto'
			})
		}
	}

	// -----------------------------------------------------------------[ BARBA UTILS ]--------------------------------------------------------//
	barba_is_view( $container, data ){
		if ( $(data.trigger).hasClass( 'barba-view' ) ){
			let $view = $container.find( '.' + $(data.trigger).attr( 'data-view' ) );
			if ( $view.length > 0 ){
				return [true,$view];
			}
		}
		return [false,$container];
	}

	barba_commons( mode, data ){
		switch ( mode ){
			case 'before':
				// set loading
				this.setLoading(true);
				// used for managing back buttom
				this.recordState( true, data );
			break;
			case 'afterLeave':
				this.initPageSpecific( $(data.current.container), false, false );
			break;

			//------> Here is when data.next.container is added to the DOM!

			case 'beforeEnter':
				// remove old container
				$(data.current.container).remove();
				// change body classes
				this.setBodyClass( data.next.html );
				// init new page
				this.initPageSpecific( $(data.next.container), true, false );
				// set scroll
				this.setPositionScrollAfterPageEnter( data );
				// track page view
				this.setGA( window.location.pathname );
				// set loading
				this.setLoading(false);
				// 
				this.updateAdminButton( data.next.html );
			break;
			case 'after':
			break;
		}
		this.$body.addClass( 'barba-mode-' + mode );
		this.LAYOUT.onBarbaChangeState( mode, data );
	}

	barba_triggerURL( url, $el ){
		if ( this.options.is_ajax ){
			barba.go( url, $el[0] );
		}
		else{
			document.location = url;
		}
	}

	barba_history_add( url, $el, title ){
		if ( this.options.is_ajax ){
			barba.history.add( url, $el[0] );
			if ( title ){
				this.changeHTMLTitle( title );
			}
		}
	}
	
	barba_history_previous(){
		return barba.history.previous;
	}

	setBodyClass( html ){
		//console.log( html );
		let parser = new DOMParser(), doc;
		doc = parser.parseFromString( html, "text/html");
		this.$body.attr( 'class', doc.body.getAttribute('class') );
		html = parser = doc = null;
	}

	changeHTMLTitle( str ){
		$('title').text( str );
	}

	onOnceReady(){
		// this.$body.addClass( 'after-fade-in' );
		this.setLoading( false );
		this.$body.addClass( 'barba-mode-once-ready' );

		if ( this.options.scrollSmooth ){
			this.LAYOUT.onOnceReady()
		}
	}
	// -----------------------------------------------------------------[ END BARBA ]--------------------------------------------------------------//


	recordState( b, data ){
		if ( b ){
			if ( data.trigger !== 'back' && data.trigger !== 'forward' ){
				this.prevSTATE = {
					html : data.current.html,
					scroll: this.getPositionScroll()
				}
			}
		}
		else{
			this.prevSTATE = false;
		}
	}

	setPositionScrollAfterPageEnter( data ){
		let y = 0;
		if ( data.trigger === 'back' || data.trigger === 'forward' ){
			if ( this.prevSTATE ){
				y = this.prevSTATE.scroll.y;
				this.recordState(false);
			}
		}
	
		if ( $(data.trigger).hasClass( 'no-barba-scroll' ) ){
			return;
		}

		gsap.to(this.$window, {duration: 0, scrollTo: y});

	}

	getPositionScroll(){
		let o = {};
		o.x = this.$window.scrollLeft();
		o.y = this.$window.scrollTop();
		return o;
	}

	// -----------------------------------------------------------------[ UTILS ]--------------------------------------------------------------//
	initLoading(){
		if ( ! this.options.is_ajax ){
			// return;
		}
		if ( NProgress ){
			NProgress.configure({ 
				trickleSpeed: 77 
			});
		}
	}

	setLoading(b){
		if ( ! this.options.is_ajax ){
			// return;
		}
		if ( NProgress ){
			if ( b ){
				NProgress.start();
				this.$body.addClass( 'page-loading' );
			}
			else{
				NProgress.done();
				this.$body.removeClass( 'page-loading' );
			}
		}
	}

	log( str, args ){
		if ( console ){
			if ( args ){
				return console.log( str, args );
			}
			console.log( str );
		}
	}

	initLazyloading(){
		lazySizes.cfg.loadMode 	= 1;
		lazySizes.init();
	}

	// -----------------------------------------------------------------[ PAGES FUNCTIONS ]---------------------------------------------------//
	initPageSpecific($context, b, firstTime){
		//this.log( 'initPageSpecific, b = ' + b );
		this.WIDGETS.initWidgets($context, b, firstTime);

		if ( b ){
			this.initLazyloading();

			setTimeout( ()=>this.initScrollSmooth(true), 17 );

			setTimeout( ()=>this.initEffex(true), Math.ceil(this.options.time_fade_in*1000) );

			
		}
		else{

			this.initScrollSmooth(false);

			this.initEffex(false);

			clearAllBodyScrollLocks();
		}

		this.initGAEvents( b, firstTime );
	}

	//------------------------------- call after a page load via jax ouside barba somewhere (eg. auto load next news) -----------------------//
	onLoadAjaxContent( href, $trigger, html, addHistory=false ){

		let parser, doc, a, title;

		this.initPageSpecific(this.$body, false, false );
		setTimeout( ()=>this.initPageSpecific(this.$body, true, false ), 120 );
			

		// ---------- create 'a' trigger --------------//
		a = document.createElement( 'a' );
		a.href = href;
		//------------ History state (change url ) -----//

		//console.log( addHistory );
		parser = new DOMParser();
		doc = parser.parseFromString( html, "text/html");
		title = doc.title;


		if ( addHistory ){
			//------------ Change HTML Page Title ----------//
			this.changeHTMLTitle( title );
			this.barba_history_add( href, $(a),  title );
		}

		html = parser = doc = null;
		
		// ----------- Google analythics ---------------//
		this.setGA ( a.pathname );
		this.setGAEvent( 'Load Next Page', 'scroll trigger', title, a.pathname );
		
	}

	// -----------------------------------------------------------------[ EFFEX ]--------------------------------------------------------------//
	initEffex(b){
		//this.log( 'initEffex, b = ' + b );
		if( b ){
			this.EFFEX.init();
		}
		else{
			this.EFFEX.destroy();
		}		
	}

	//------------------------------------------------------------------[ GOOGLE ANALYTHICS ]--------------------------------------------------//
	setGA( pathname ){

		if ( this.isLoggedIn() ){
			return;
		}

		this.log( 'setGA, pathname = ' + pathname + ', gtag = ' + gtag + ', ga = ' + ga );
		
		if ( gtag ){
			gtag(	
				'config', 
				this.options.GA_MEASUREMENT_ID,
				{
					'page_path': pathname 
				}
			);
		}
		else if ( ga ){
			ga('set', 'page', pathname );
			ga('send', 'pageview')
		}

	}

	setGAEvent( category, action, label, value ){

		return;

		let event_name;
		
		if ( this.isLoggedIn() ){
			return;
		}

		/*
			action: 	text, 		required
			category: 	text, 		required
			label: 		text, 		(optional)
			value: 		integer, 	(optional)
		*/


		switch( category ){
			case 'Newsletter Signup':
				event_name = 'lgdr_mailchimp_signup';
				if ( label === 'popup' ){
					event_name = 'lgdr_mailchimp_popup_signup';
				}
				break;
			case 'Inquiry Form Submit':
				event_name = 'lgdr_inquiry_form';
				break;
			case 'Video Play':
				event_name = 'lgdr_video_play';
				break;
			case 'Video Pause':
				event_name = 'lgdr_video_pause';
				break;
			case 'Scroll Activity':
				event_name = 'lgdr_scroll_activity';
				break;
			case 'Email Click':
				event_name = 'lgdr_email_send';
				break;
			case 'Social Click':
				event_name = 'lgdr_social_click';
				break;
			case 'PDF Download':
				event_name = 'lgdr_pdf_download';
				break;
			case 'Audio Play':
				event_name = 'lgdr_audio_play';
				break;
			case 'Audio Pause':
				event_name = 'lgdr_audio_pause';
				break;
			default:
				event_name = category;
				
		}


		this.log( 'setGAEvent, event_name = ' + event_name + ', action = ' + action + ', label = ' + label + ', value = ' + value );
		
		if ( gtag ){ 
			gtag( 'event', event_name, 
				{
					'event_action': action,
					'event_label': label,
					'evet_value': value
				}
			);
		}
		/*
		else if ( ga ){
			ga('send', 'event', category, action, label, value );
		}
		*/
	}

	// call each time from initPageSpecific to hook events need as button clicks ...
	initGAEvents( b, firstTime){

		return;
		
		let title = $('h1.page-title').text(), $a;
		const 	loc = document.location,
				queryString = loc.search;

		if ( title === '' ){
			title = $('title').text();
		}


		if ( b ){

			// only once, ie footer events
			if ( firstTime ){

				// 4) Social Links
				$( '.module-socials a' ).on( 'click', (e)=>{
					$a = $(e.currentTarget);
					this.setGAEvent( 'Social Click', 'Social Click', $a.attr( 'href' ), loc.href );
				});
			
			}  

			// from widget it's automatic call from:
			/*
			1) mailchimpNewsletter Form
			this.main.setGAEvent( 'Newsletter Signup', 'Newsletter Signup',  location , document.location.href )

			2) popUpWindow
			this.main.setGAEvent(  'Inquiry Form Submit', 'Inquiry Form Submit', this.$el.find('.title').html() , document.location.href  )

			5) videoPlay clicks (videoPlayer.js)
			this.main.setGAEvent(  paused  ? 'Video Play' : 'Video Pause' , 'Video Play/Video Pause', this.$iframe.attr( 'src' ) , document.location.href  );

			7: Scroll Event, call from Effect.js
			this.main.setGAEvent( 'Scroll Activity', 'Scroll Activity', 'center', self.direction );
			*/

			//3) bio & contact emails
			if ( this.$body.hasClass( 'page-template-ourstory-bio' ) || this.$body.hasClass( 'page-template-contact' ) ){
				$('a').on( 'click', (e)=>{
					$a = $(e.currentTarget);
					if ( $a.attr( 'href' ).indexOf( 'mailto:' ) !== -1 ){
						this.setGAEvent( 'Email Click', 'Email Click', $a.attr( 'href' ).split(':')[1], loc.href );
					}
				})
			}

			//6) File Downloads
			$( '.file-download a' ).on( 'click', (e)=>{
				a = $(e.currentTarget);
				this.setGAEvent( 'PDF Download', 'PDF Download', $a.attr( 'href' ), loc.href );
			} )

		}
	}

	//----------------------------------------------------------------[ UTILS ]------------------------------------------------------------//
	getPageID(){
		let classes, i, c, search_class;
		classes = this.$body.attr( 'class' ).split( ' ' );
		search_class = this.$body.hasClass( 'page-template' ) ? 'page-id-' : 'postid-';

		i = classes.length;
		while( i-- ){
			c = classes[i];
			if ( c.indexOf( search_class ) !== -1 ){
				return c.split( search_class )[1];
				break;
			}
		}
		return false;
	}

	updateAdminButton( html ){

        let  $el = $( this.options.admin_button );

		// let  $el = $( this.options.admin_button ), id, url, href;
		// if ( $el.length <= 0 ){
		// 	return;
		// }
		
		// id = this.getPageID();
  
		// if ( id !== false ){
		// 	href = $el.find( 'a' ).attr( 'href' );
		// 	if ( href ){
		// 		if ( href.indexOf( '?' ) !== -1 ){
		// 			url = href.split( '?' )[0];
		// 			$el.find( 'a' ).attr( 'href', url + '?post=' + id + '&action=edit' );
		// 		}
		// 	}
		// }

        let parser = new DOMParser(), doc;
        doc = parser.parseFromString( html, "text/html" );
        $el.find( 'a' ).attr( 'href', $(doc).find(this.options.admin_button + ' a' ).attr('href') );
	}

	isLoggedIn(){
		return this.$body.hasClass( 'logged-in' );
	}

	/*
		Remove the Outline in an Accessible Way
		https://betterprogramming.pub/a11y-never-remove-the-outlines-ee4efc7a9968
		https://github.com/nuclei/unfocus

	*/
	outlineInAccessibleWay(){

	
		let styleText = '::-moz-focus-inner{border:0 !important;}:focus{outline: none !important;',
			unfocus_style = document.createElement('STYLE');

		window.unfocus = function(){

			document.getElementsByTagName('HEAD')[0].appendChild(unfocus_style);

			document.addEventListener('mousedown', function(){
				unfocus_style.innerHTML = styleText+'}';
			});
			document.addEventListener('keydown', function(){
				unfocus_style.innerHTML = '';
			});
		};

		unfocus.style = function(style){
			styleText += style;
		};

		unfocus();
	
	}


	// -----------------------------------------------------------------[ FOUO SIGNATURE ]-----------------------------------------------------//
	_logFOUO( str ){
		this.log( '' );
		this.log('%c' + str, 'color: white; background-color: black; font-size: 12px; line-height: 28px; padding: 10px 15px 8px 15px; font-family: Helvetica;' );
		this.log( '' );  

	}

}
